import { Component, OnInit } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';

@Component({
  selector: 'side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.scss'],
})
export class SideBarComponent implements OnInit {
  isSidebarButtonToggled = false;
  bodyTag = document.body;
  userAccount: AccountInfo;

  accordionOpen = false;


  constructor(private authService: MsalService) { }

  ngOnInit(): void {
    this.userAccount = this.authService.instance.getActiveAccount();  
  }

  toggleClass() {
  }

  toggleSideBar() {
    const sidebar = document.getElementById('sidebar');
    const mainContainer = document.getElementById('mainContainer');

    if (sidebar !== null && mainContainer != null) {
      if (!this.isSidebarButtonToggled) {
        sidebar.classList.add('sidebar--collapse');
        mainContainer.classList.add('main-container--expand');
        this.bodyTag.classList.add("body-sidebar-collapsed");
        this.isSidebarButtonToggled = true;

      } else {
        sidebar.classList.remove('sidebar--collapse');
        mainContainer.classList.remove('main-container--expand');
        this.bodyTag.classList.remove("body-sidebar-collapsed");
        this.isSidebarButtonToggled = false;
      }
    }
  }

  logout() {
    this.authService.logout();
  }
}
